import { LanguagesType } from 'constants/languages';

import { ActionTypes, State, Action } from './types';

const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case ActionTypes.SET_BLOCKED_VISIBLE:
      return { ...state, isBlockedVisible: action.data as boolean };
    case ActionTypes.SET_TMP_TOKEN:
      return { ...state, tmpToken: action.data as string };
    case ActionTypes.SET_LANGUAGES:
      return { ...state, languages: action.data as LanguagesType[] };
    default:
      return state;
  }
};

export default reducer;
